module.exports = __webpack_public_path__ + "img/We.b39c8db2.png";